export const defaultTranslationMapping = {
  Acabamento: 'finishing',
  Fabricação: 'fabrication',
  'CMC total': 'totalCmc',
  'Comprimento (mm)': 'lengthInMm',
  'Custo por Kg': 'costPerKg',
  'Custo por mm': 'costPerMm',
  'Custo total': 'totalCost',
  Código: 'code',
  'Data de recebimento': 'receivedDate',
  Densidade: 'density',
  'Dimensão 1': 'dimension1',
  'Dimensão 2': 'dimension2',
  Formato: 'format',
  Fornecedor: 'supplier',
  Material: 'material',
  NCM: 'ncm',
  'Nº de corrida': 'heatNumber',
  'Nº de rastreamento': 'trackingNumber',
  Descrição: 'description',
  Característica: 'characteristic',
  Família: 'family',
  'Ordem de compra': 'purchaseOrder',
  'País de Origem': 'originCountry',
  'Peso total (kg)': 'totalWeight',
  'Quantidade (pç)': 'quantity',
  'Tratamento térmico': 'heatTreatment',
  Unidade: 'measurementUnit',
}
